
const locationReducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state
  }
};

export default locationReducer;